import { useTranslation } from 'react-i18next'
import { Link, useLocation, useParams } from 'react-router'
import cx from 'helpers/cx'

import { ArrowLeftLargeIcon } from '@pleio/icons/arrow-left-large'

import FetchMore from 'js/components/FetchMore'
import { H3 } from 'js/components/Heading'
import IconButton from 'js/components/IconButton'
import Modal from 'js/components/Modal/Modal'
import VersionListItem from 'js/components/VersionHistory/VersionListItem'

import styles from './VersionList.module.css'

const VersionList = ({
    entity,
    revisions,
    updating = false,
    fetchMore,
    className,
    ...rest
}) => {
    const { t } = useTranslation()
    const location = useLocation()
    const { revisionGuid } = useParams()

    return (
        <div className={cx(styles.wrapper, className)} {...rest}>
            <div className={styles.historyHeader}>
                <IconButton
                    as={Link}
                    to={location?.state?.prevPathname || entity.url}
                    size="large"
                    variant="secondary"
                    tooltip={t('action.back')}
                    style={{ margin: '0 2px' }}
                >
                    <ArrowLeftLargeIcon />
                </IconButton>
                <H3 as="h1">{t('version.version-history')}</H3>
            </div>

            <Modal
                size="small"
                isVisible={updating}
                title={t('version.loading-latest-version')}
            >
                {t('version.loading-latest-version-description')}
            </Modal>

            <FetchMore
                as="ul"
                className={styles.historyVersionList}
                edges={revisions.edges}
                getMoreResults={(data) => data.revisions.edges}
                fetchMore={fetchMore}
                fetchCount={50}
                isScrollableBox
                maxLimit={revisions.total}
                resultsMessage={t('global.result', {
                    count: revisions.total,
                })}
                fetchMoreButtonHeight={48}
            >
                {revisions.edges.map((revision, i) => {
                    const isLatest = i === 0

                    return (
                        <VersionListItem
                            key={revision.guid}
                            revision={revision}
                            url={`/${entity.guid}/version-history/${revision.guid}`}
                            isActive={
                                revisionGuid
                                    ? revisionGuid === revision.guid
                                    : isLatest
                            }
                            isLatest={isLatest}
                        />
                    )
                })}
            </FetchMore>
        </div>
    )
}

export default VersionList
